// MapToggle - Floating button to toggle between grid and map view

import React from 'react';
import { Map, LayoutGrid } from 'lucide-react';

interface MapToggleProps {
  isMapView: boolean;
  onToggle: () => void;
  className?: string;
  disabled?: boolean;
}

export function MapToggle({
  isMapView,
  onToggle,
  className = '',
  disabled = false,
}: MapToggleProps) {
  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      className={`
        flex items-center gap-2 px-4 py-2.5
        bg-gray-900 text-white
        rounded-full shadow-lg
        hover:bg-gray-800
        transition-all
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
    >
      {isMapView ? (
        <>
          <LayoutGrid className="w-4 h-4" />
          <span className="text-sm font-medium">Liste</span>
        </>
      ) : (
        <>
          <Map className="w-4 h-4" />
          <span className="text-sm font-medium">Karte</span>
        </>
      )}
    </button>
  );
}

export default MapToggle;
